import type { PlayPauseButtonProps } from './PlayPauseButton'
import { PlayPauseButton } from './PlayPauseButton'
import { StyledPlayerButtonRow } from './PlayerButtonRow.styles'
import { RewindButton } from './RewindButton'

export interface PlayerButtonRowProps
  extends Omit<PlayPauseButtonProps, 'size'> {
  onRewind: () => void
}

export function PlayerButtonRow(props: PlayerButtonRowProps): JSX.Element {
  return (
    <StyledPlayerButtonRow>
      <RewindButton onClick={props.onRewind} />
      <PlayPauseButton
        state={props.state}
        onPause={props.onPause}
        onPlay={props.onPlay}
      />
    </StyledPlayerButtonRow>
  )
}
